import { LightOption } from './generated/graphql'
import { SetNonNullish } from '../../utils/SetNonNullish'
import { uniqBy } from 'lodash'

type Options = { type?: 'aos' | 'asi' | string | null | undefined }

const parensRegExp = /\(([^)]+)\)/

/**
 * Handles invalid lights
 * e.g. missing lightCode or description
 *
 * Handles 'Unknown' lights
 *
 * Handles the differences between AOS and ASI lights
 */
export const lightOptionsNormalizer = (lights: LightOption[], options?: Options) => {
    const { type } = options || {}

    /* Must have unique light codes and a lightDescription */
    const cleanedLights = uniqBy(
        lights.filter(
            (light): light is SetNonNullish<LightOption, 'lightCode' | 'lightDescription'> =>
                !!light.lightCode && !!light.lightDescription,
        ),
        'lightCode',
    )

    if (type?.toLowerCase() === 'aos') {
        return cleanedLights.map((light) => {
            const trimmedDescription = light.lightDescription.trim().toUpperCase()
            const isUnknown = trimmedDescription === 'UNKNOWN'

            if (isUnknown) {
                return {
                    avatar: '?',
                    label: 'UNKNOWN',
                    value: light.lightCode,
                }
            }

            // 'R&D W/Conditions (Green, Yellow)'
            const match = trimmedDescription.match(parensRegExp)

            if (match) {
                // 'R&D W/CONDITIONS'
                const updatedDescription = trimmedDescription.replace(parensRegExp, '').trim().toUpperCase()
                // GY
                const updatedCode = match[1]
                    .split(' ')
                    .map((s) => s.charAt(0))
                    .join('')

                return {
                    avatar: updatedCode,
                    label: updatedDescription,
                    value: light.lightCode,
                }
            }

            return {
                avatar: light.lightCode.trim().toUpperCase(),
                label: light.lightDescription.trim().toUpperCase(),
                value: light.lightCode,
            }
        })
    }

    if (type?.toLowerCase() === 'asi') {
        return cleanedLights.map((light) => {
            const isUnknown = light.lightDescription.trim().toUpperCase() === 'UNKNOWN'

            if (isUnknown) {
                return {
                    avatar: '?',
                    label: 'UNKNOWN',
                    value: light.lightCode,
                }
            }

            return {
                avatar: light.lightCode.trim().toUpperCase(),
                label: light.lightDescription.trim().toUpperCase(),
                value: light.lightCode,
            }
        })
    }

    // Generic
    return cleanedLights.map((light) => {
        return {
            avatar: light.lightCode,
            label: light.lightDescription,
            value: light.lightCode,
        }
    })
}
